// Dashboard path for a given user role
export const dashPath = (role) => {
  if (role === "admin") return "/admin";
  if (role === "provider") return "/provider";
  if (role === "host") return "/host";
  return "/customer";
};

export const isDev = process.env.NODE_ENV !== "production";

export const logErr = (msg, e) => {
  if (isDev && !e?.silent) {
    console.error(msg, e);
  }
};
